import { useEffect, useState } from 'react'
import { useMediaQuery } from '../useMediaQuery';
import { useStyletron } from 'baseui'

function useIsMobile(): boolean {
    const [, theme] = useStyletron();
    const isLargeScreen = useMediaQuery(theme.mediaQuery.large.replace('@media ', ''));
    const isIphone = useMediaQuery("only screen and (min-device-width: 300px) and (max-device-width: 850px)  and (-webkit-device-pixel-ratio: 3)");
    const isIpad = useMediaQuery("only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: landscape)");
     /* ----------- iPad Pro 12.9" ----------- */
    const isIpadPro = useMediaQuery("only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)");
        
      return !isLargeScreen || isIphone || isIpad || isIpadPro;
}

export default useIsMobile
